import React, { useState, useEffect } from 'react';
import { Col, Container, InputGroup, Row } from 'react-bootstrap';
import AddButton from 'src/Admin/components/User/UserFormNew/components/AddButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import List from './List';

const Employer = ({ blobData, dispatch, setBlobData, fetchData }) => {
  const [openEmployerModal, setOpenEmployerModal] = useState(false);
  const [searchEmployerText, setSearchEmployerText] = useState('');
  const [employerDataLocal, setEmployerDataLocal] = useState({});

  const [openEmployerModalForRange, setOpenEmployerModalForRange] =
    useState(false);
  const [searchEmployerTextFrom, setSearchEmployerTextFrom] = useState('');
  const [searchEmployerTextTo, setSearchEmployerTextTo] = useState('');

  useEffect(() => {
    setEmployerDataLocal(blobData);
  }, []);

  const selectChangeHandler = (e) => {
    const { name, checked, id } = e.target;
    const tempBlob = blobData?.allEmployerData?.map((blob) =>
      blob?.ClientId === id
        ? { ...blob, isChecked: true }
        : { ...blob, isChecked: false },
    );
    setEmployerDataLocal({
      ...employerDataLocal,
      allEmployerData: tempBlob,
      selectedEmployerData: tempBlob?.filter(
        (item) => item?.isChecked === true,
      )[0],
    });
  };

  return (
    <div>
      <div className="heading-container">
        <span className="blob-heading">Employer(s)</span>
        <span className="blob-data">
          (
          {blobData?.selectedEmployerData?.oid ? '1 Employer' : 'All Employers'}
          )
        </span>
      </div>
      {!(
        blobData?.selectedEmployerData?.oid ||
        blobData?.selectedLocationData?.oid
      ) && (
        <div className="block-of-business-container">
          <div className="flex-1">
            <AddButton
              onClick={() => setOpenEmployerModal(true)}
              className={'add-button-active reports-blob-button'}
              label="Select Employer by name or ID"
            />
          </div>
          <span className="or-saperator">OR</span>
          <div className="flex-1">
            <AddButton
              onClick={() => {
                setOpenEmployerModalForRange(true);
              }}
              className={'add-button-active reports-blob-button'}
              label="Select a Range"
            />
          </div>
        </div>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openEmployerModal || openEmployerModalForRange}
        onHide={() => {
          setSearchEmployerText('');
          setOpenEmployerModal(false);

          setSearchEmployerTextFrom('');
          setSearchEmployerTextTo('');
          setOpenEmployerModalForRange(false);
        }}
        applyFilterHandler={() => {
          if (openEmployerModal) {
            dispatch(
              setBlobData({
                empType: 'single',
                allEmployerData: employerDataLocal?.allEmployerData,
                selectedEmployerData:
                  employerDataLocal?.allEmployerData?.filter(
                    (item) => item?.isChecked === true,
                  )[0],
              }),
            );
            setOpenEmployerModal(false);
          } else if (openEmployerModalForRange) {
            dispatch(
              setBlobData({
                empType: 'range',
                allEmployerData: [],
                selectedEmployerData: {
                  from: searchEmployerTextFrom,
                  to: searchEmployerTextTo,
                },
              }),
            );
            setOpenEmployerModalForRange(false);
          }
        }}
        showCancel={true}
        titleLabel="Employer(s)"
        showApply={true}
        showApplyLabel={openEmployerModal ? 'Add Selected' : 'Add Range'}
        customClasses="reports-blob-modal"
      >
        <Container className="mt-3 mb-3">
          {openEmployerModal ? (
            <>
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="Block of Business"
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: 'Search by name or Employer ID',
                        value: searchEmployerText,
                        onChange: (e) => {
                          setSearchEmployerText(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="mb-1">
                  <List
                    //data={blobDataLocal?.allBlobData?.length > 0 ?  blobDataLocal?.allBlobData : blobData?.allBlobData}
                    selectChangeHandler={selectChangeHandler}
                    displayId="ClientId"
                    displayLabel="ClientName"
                    labelIdText="Employer ID"
                    searchString={searchEmployerText}
                    modalFor="employer"
                    fetchData={fetchData}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="From Employer ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchEmployerTextFrom,
                        onChange: (e) => {
                          setSearchEmployerTextFrom(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="To Employer ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchEmployerTextTo,
                        onChange: (e) => {
                          setSearchEmployerTextTo(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </FilterModal>
    </div>
  );
};

export default Employer;
